module.exports = __webpack_public_path__ + "img/18CASACCA-ELBA-U--STAMPE-LINO-UNITI-LINO6.44f2447e.jpg";